
import Vue from "vue";
import Countdown from "./Countdown.vue";
import msDataProvider from "../../../../services/msDataProvider";
import uiService from "../../../../services/uiService";
import errorService from "../../../../services/errorService";
import issueBaseline from "../../../../constant/issueBaseline";
import i18n from "@/lang";
import {addAction} from "@/services/firebase/writeData";

export default Vue.extend({
  components: {
    Countdown,
  },
  props: ["app", "selected", "authenInfo", "sdpConnected", "deviceVerifyResult"],
  data() {
    return {
      i18n,
      stepResolve: [],
      rescan: false,
      rescanAlert: false,
      pathImg: "",
      quickFixTips: false,
      os: null,
      issueBaselineResolve: {},
      switchApp: false,
      expiredDuration: false,
      errorService,
      binding: {},
      opening: false,
      stopping: false,
      showPopupIssue: false,
      baselineFaileList: [],
      requestConnectScope: {
        rules: {
          message: [(v) => !!v || this.$t("SDP_APP.MESSAGE_TO_ADMINISTRATOR")],
        },
        dialog: false,
        params: {},
        loading: false,
        valid: false,
      },
      count: 1
    };
  },
  watch: {
    deviceVerifyResult: {
      handler(val) {
        if (val && val.baseline_verify_results) {
          this.showPopupIssueBaseline()
        }
      },
      deep: true
    },
    app: {
      handler(val) {
        this.switchApp = !!val?.started;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    switchable() {
      return (
          this.app &&
          (!this.app?.started &&
              !this.app.authorized_app.app.parent &&
              (!this.app.authorized_app.error_info ||
                  !this.app.authorized_app.error_info.error_code ||
                  this.app.authorized_app.error_info.error_code === 408) &&
              !this.app.restarting &&
              !this.app.starting) ||
          this.app.started ||
          this.app.restarting ||
          this.app.starting
      );
    },
    clickable() {
      return (
          this.app &&
          this.sdpConnected &&
          this.app?.started &&
          (this.app.app_proxy_info.launch_url ||
              (this.app.authorized_app.app.destination_setting.http_setting &&
                  this.app.authorized_app.app.destination_setting.http_setting
                      .enabled) ||
              this.app.app_proxy_info.content_protection_mode)
      );
    },
    needApproveApp() {
      return this.app?.authorized_app?.error_info?.error_code === 401;
    },
    isAppNameCenter() {
      return !this.needApproveApp && !this.app?.started && !this.app?.authorized_app?.error_info?.error_code && !this.app.error;
    },
    startAble() {
      return !this.app?.started && !this.app?.starting && !this.needApproveApp
    },
    hasBaselineIssue() {
      return this.app?.authorized_app?.error_info?.error_code === 417
    },
    isBlockNetwork() {
      try {
        return this.app?.app_proxy_info.applied_access_policies.find(app => app?.network_setting?.block_all)
      } catch (e) {
        return false;
      }
    },
    declineApproveApp() {
      return this.needApproveApp && this.app?.authorized_app?.access_request?.status === 'Declined'
    },
    pendingApproveApp() {
      return this.needApproveApp && this.app?.authorized_app?.access_request?.status === 'Pending'
    },
    hasError() {
      return  (this.app?.authorized_app?.error_info?.error_code !== 202 && this.app?.authorized_app?.error_info?.message || this.app?.error) && !this.needApproveApp;
    },
    hasLoading() {
      return this.app?.authorized_app?.error_info?.error_code == 202
    }
  },
  methods: {
    openDetail() {
      this.$emit('openDetail', {app: this.app});
    },
    async expiredTime(val) {
      this.expiredDuration = val;
    },
    appSwitchHandler() {
      if (this.app.authorized_app?.error_info?.error_code === 401) {
        uiService.executeCommand('requestConnect', this.app);
        return;
      }
      if (!this.switchApp) {
        this.stop();
      } else {
        this.start();
      }
    },
    open() {
      if (!this.app.started || !this.clickable) {
        return;
      }
      this.opening = true;
      setTimeout(async () => {
        await new Promise((f) => setTimeout(f, 500));
        await uiService.executeCommand(
            "try",
            {
              async func() {
                const data = await msDataProvider.executeCommand(
                    "sdpOpenApp",
                    this.app.authorized_app.app.app_id
                );
                if (
                    data.error_info &&
                    data.error_info.error_code &&
                    data.error_info.message
                ) {
                  await uiService.executeCommand("alertShow", {
                    message: data.error_info.message,
                  });
                }
              },
              self: this,
            },
            true
        );
        this.opening = false;
      }, 1000);
    },
    handleEventClickApp() {
      if (this.app.restarting || this.app.starting) {
        return;
      }

      if (this.hasBaselineIssue) {
        this.$emit('resolveIssueBaseline', {app: this.app});
        return;
      }
      if (this.needApproveApp && !this.declineApproveApp && !this.pendingApproveApp) {
        this.$emit('requestApprove', {app: this.app});
        return;
      }
      if (this.hasError) {
        return;
      }
      if (this.startAble) {
        this.start();
        return;
      }
      if (this.clickable) {
        this.open();
        return;
      }

    },
    async issueStart(keyIssue) {
      await addAction(`[Issue]_${keyIssue}_start`)
    },
    async issueEnd(keyIssue) {
      await addAction(`[Issue]_${keyIssue}_end`)
    },
    issueEvent(callback) {
      if (this.deviceVerifyResult?.baseline_verify_results?.length) {
        const baseLineVerifyResults = this.deviceVerifyResult.baseline_verify_results
        for (let i = 0; i < baseLineVerifyResults.length; i++) {
          if (baseLineVerifyResults[i]?.rule_verify_results_allow?.length) {
            const ruleVerifyResultsAllow = baseLineVerifyResults[i].rule_verify_results_allow
            for (let j = 0; j < ruleVerifyResultsAllow.length; j++) {
              if (ruleVerifyResultsAllow[j].key) {
                if (sessionStorage.getItem(ruleVerifyResultsAllow[j].key) !== null) {
                  sessionStorage.removeItem(ruleVerifyResultsAllow[j].key)
                  this.issueEnd(ruleVerifyResultsAllow[j].key);
                }
              }
            }
          }
          if (baseLineVerifyResults[i]?.rule_verify_results_not_allow?.length) {
            const ruleVerifyResultsNotAllow = baseLineVerifyResults[i].rule_verify_results_not_allow
            for (let j = 0; j < ruleVerifyResultsNotAllow.length; j++) {
              if (ruleVerifyResultsNotAllow[j].key) {
                if (sessionStorage.getItem(ruleVerifyResultsNotAllow[j].key) === null) {
                  sessionStorage.setItem(ruleVerifyResultsNotAllow[j].key, "false")
                  this.issueStart(ruleVerifyResultsNotAllow[j].key);
                }
              }
            }
          }

        }
      }
      this.sleep(callback);
    },
    async sleep(callback) {
      await new Promise((resolve) => setTimeout(resolve, 30000));
      callback(this.issueEvent);
    },
    showPopupIssueBaseline() {
      if (!this.deviceVerifyResult) {
        return;
      }
      const issueDeviceList = [];
      const issueList = issueBaseline;
      this.baselineFaileList = [];
      if (
          this.app &&
          this.app.authorized_app &&
          this.app.authorized_app.failed_device_baseline_ids &&
          this.app.authorized_app.failed_device_baseline_ids.length
      ) {
        for (const issueId of this.app.authorized_app
            .failed_device_baseline_ids) {
          for (const resultDevice of this.deviceVerifyResult
              .baseline_verify_results) {
            if (issueId === resultDevice.baseline_id) {
              for (const issueDevice of resultDevice.rule_verify_results) {
                if (!issueDevice.result) {
                  issueDeviceList.push(issueDevice);
                }
              }
            }
          }
        }
      }
      if (issueDeviceList.length > 0) {
        for (const issue of issueDeviceList) {
          for (const item of issueList) {
            if (item.key === issue.key) {
              issue.rule.url = item.url;
              this.baselineFaileList.push(issue);
            }
          }
        }
      }
    },
    start() {
      uiService.executeCommand("try", {
        async func() {
          await msDataProvider.executeCommand("sdpStartApp", {
            app_id: this.app.authorized_app.app.app_id,
          });
        },
        self: this,
      });
    },
    async stop() {
      this.stopping = true;
      await msDataProvider.executeCommand(
          "sdpStopApp",
          this.app.authorized_app.app.app_id
      );
      this.stopping = false;
    },
    getDefaultStatusApp() {
      if (this.app &&
          !this.app.started &&
          !this.app.authorized_app.app.parent &&
          (!this.app.authorized_app.error_info ||
              !this.app.authorized_app.error_info.error_code ||
              this.app.authorized_app.error_info.error_code === 408) &&
          !this.app.restarting &&
          !this.app.starting
      ) {
        this.switchApp = false;
      } else {
        this.switchApp = true;
      }
    },
  },
  async created() {
    this.os = sessionStorage.getItem("os");
    this.issueEvent(this.issueEvent);
    this.getDefaultStatusApp();
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
});
